import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { Zap, Menu, X } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const MarketingHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { label: "Features", path: "/features" },
    { label: "Pricing", path: "/pricing" },
    { label: "About", path: "/about" },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="border-b border-border">
      <nav className="container mx-auto px-4 py-4 flex items-center justify-between">
        {/* Logo */}
        <div 
          className="flex items-center gap-2 cursor-pointer" 
          onClick={() => navigate('/')} 
          role="button"
        >
          <Zap className="w-6 h-6 text-primary" />
          <span className="text-xl font-bold text-foreground">StudyForge</span>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-4">
          {navLinks.map((link) => (
            <Button 
              key={link.path}
              variant="ghost" 
              onClick={() => {
                trackEvent('nav_link_clicked', { link: link.label, source: location.pathname });
                navigate(link.path);
              }}
              className={isActive(link.path) ? "text-primary" : ""}
            >
              {link.label}
            </Button>
          ))}
          <Button onClick={() => {
            trackEvent('header_cta_clicked', { source: location.pathname });
            navigate('/auth');
          }}>
            Get Started Free
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <Button
          variant="ghost"
          size="icon"
          className="md:hidden"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
        >
          {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </Button>
      </nav>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t border-border bg-background">
          <div className="container mx-auto px-4 py-4 flex flex-col gap-2">
            {navLinks.map((link) => (
              <Button 
                key={link.path}
                variant="ghost" 
                className={`justify-start ${isActive(link.path) ? "text-primary" : ""}`}
                onClick={() => {
                  trackEvent('nav_link_clicked', { link: link.label, source: location.pathname, mobile: true });
                  navigate(link.path);
                  setMobileMenuOpen(false);
                }}
              >
                {link.label}
              </Button>
            ))}
            <Button 
              className="mt-2" 
              onClick={() => {
                trackEvent('header_cta_clicked', { source: location.pathname, mobile: true });
                navigate('/auth');
                setMobileMenuOpen(false);
              }}
            >
              Get Started Free
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default MarketingHeader;
